<template>
  <div class="main text-left">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active" aria-current="page">创作者中心</li>
      </ol>
    </nav>
    <div class="alert alert-info" role="alert">
      <router-link class="alert-link" to="/post">{{ this.$t('lang.title.post') }}</router-link><br>
      <router-link class="alert-link mt-5" to="/genarate">图文生成</router-link><br>
    </div>
    <div class="alert alert-info" role="alert">
      <a class="alert-link mt-5" href="#" v-on:click="initOptions">数据同步</a><br>
    </div>
    <div class="alert alert-info" role="alert">
      <router-link class="alert-link" to="/profile">{{ this.$t('lang.toolbar.Profile')
        }}</router-link><br>
      <router-link class="alert-link mt-5" to="/PasswordChange"> {{
        this.$t('lang.toolbar.PasswordChange')
      }}</router-link><br>
    </div>
    <div class="alert alert-info" role="alert">
      {{ this.$store.state.userinfo.username }}<br>
      <a class="alert-link mt-5" v-on:click="logout" href="#"> {{ this.$t('lang.toolbar.Logout') }}</a>
    </div>
  </div>
</template>
<script>
import { Modal } from 'bootstrap'
import sx from '../utils/core.js'
import $ from 'jquery'
// Make it available globally as it needs to be accessible within the single file components (.vue)
window.$ = $

export default {
  mounted() {
    const that = this
    that.$store.state.categorylist = JSON.parse(localStorage.getItem('categorylist') || '[]')
    that.$store.state.taglist = JSON.parse(localStorage.getItem('taglist') || '[]')
    that.$store.state.codelist = JSON.parse(localStorage.getItem('codelist') || '[]')
    that.$store.state.dict = JSON.parse(localStorage.getItem('dict') || '{}')
    document.title = "Console - guavaslink"
    that.$store.state.confirmdef2 = {
      title: that.$t('lang.toolbar.Confirm'),
      msg: that.$t('lang.msg.toLogout'),
      event: 'logout'
    }
  },
  methods: {
    initOptions() {
      const that = this;
      var params = {
        bucketid: '13',
        options: JSON.stringify({}),
        token: localStorage.getItem("token") || "token"
      };
      var url = that.$store.state.baseurl + '/app/cmshelper/fetchSelectOptions'
      const mymodal = sx.showWaiting()
      sx.request(
        url,
        params,
        function (result) {
          if (result.status === "ok") {
            that.saveOptsToStorage(result)
          } else {
            // sx.toastError(that.$t('lang.error.failedRequest', { err: result.message }));
          }
        },
        function (result) {
          console.log(result)
          sx.login(
            url,
            params,
            function (result) {
              if (result.status === 'ok') {
                that.saveOptsToStorage(result)
              } else {
                // sx.toastError(that.$t('lang.error.failedRequest', { err: result.message }));
              }
            }
          )
        }
      );
      sx.hideWaiting(mymodal);
    },
    saveOptsToStorage(result) {
      const that = this
      that.$store.state.categorylist = result.data.categorylist
      that.$store.state.codelist = result.data.codelist || []
      that.$store.state.dict = result.data.dict || {}
      that.$store.state.taglist = result.data.taglist
      localStorage.setItem('codelist', JSON.stringify(that.$store.state.codelist))
      localStorage.setItem('dict', JSON.stringify(that.$store.state.dict))
      localStorage.setItem('taglist', JSON.stringify(that.$store.state.taglist))
      localStorage.setItem('categorylist', JSON.stringify(that.$store.state.categorylist))
    },
    logout() {
      const that = this
      const myconfirmModal = new Modal(document.querySelector("#myModalConfirm2"));
      myconfirmModal.show();
      $("#confirm2").click(function () {
        myconfirmModal.hide();
        if (that.$store.state.confirmdef2.event != "logout") {
          return
        }
        localStorage.setItem('token', '')
        localStorage.setItem('authenticated', false)
        localStorage.setItem('userinfo', '{}')
        that.$store.state.authenticated = false
        if ((that.$route.path != '/login')) {
          that.$router.replace({ name: 'Login' })
        }
      })
    }
  }
}
</script>
